module.exports = __webpack_public_path__ + "img/img_C3.12.16.91fbfa13.png";